import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

const AdminBreadcrumb = () => {
  const location = useLocation();
  const paths = location.pathname.replace("/admin", "").split("/").filter(Boolean);

  const getBreadcrumbName = (path) => {
    const nameMap = {
      dashboard: "Dashboard",
      "product-types": "Product Types",
      products: "Products",
      settings: "Settings",
      roles: "Roles",
      permissions: "Permissions",
      new: "Add New",
      edit: "Edit",
    };
    if (nameMap[path]) return nameMap[path];
    if (/^\d+$/.test(path)) return `#${path}`;
    return path.charAt(0).toUpperCase() + path.slice(1).replace(/-/g, " ");
  };

  if (paths.length === 0) return null;

  return (
    <nav className="flex items-center gap-2 text-sm text-text-secondary mb-4">
      <Link
        to="/admin/dashboard"
        className="flex items-center gap-1 hover:text-text-primary transition-colors no-underline"
      >
        <Home size={16} />
        <span className="hidden sm:inline">Home</span>
      </Link>
      {paths.map((path, index) => {
        const isLast = index === paths.length - 1;
        const href = "/admin/" + paths.slice(0, index + 1).join("/");
        const name = getBreadcrumbName(path);
        return (
          <span key={href} className="inline-flex items-center gap-2">
            <ChevronRight size={16} className="text-text-secondary shrink-0" />
            {isLast ? (
              <span className="text-text-primary font-medium">{name}</span>
            ) : (
              <Link to={href} className="hover:text-text-primary transition-colors no-underline">
                {name}
              </Link>
            )}
          </span>
        );
      })}
    </nav>
  );
};

export default AdminBreadcrumb;
